import { useForm } from 'react-hook-form'

import { yupResolver } from '@hookform/resolvers/yup'
import { TextInput } from '@ui/components/core/TextInput'
import { DynamicFormProps } from '@ui/interfaces'
import { isValidUrl } from '@ui/lib/helpers/validationHelpers'
import { SaveAndCancelButtons } from '@ui/pages/pipelinesWorkflow/components/DestinationForms/SaveAndCancelButtons'
import * as Yup from 'yup'

const schema = Yup.object({
  dsn: Yup.string().test('is-url-valid', 'DSN is not valid', isValidUrl).required('DSN must be provided'),
  environment: Yup.string(),
}).required()

export default function Sentry(props: DynamicFormProps) {
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(schema),
    defaultValues: {
      ...props.config,
    },
  })

  const { saveClick, cancelClick } = props

  return (
    <form onSubmit={handleSubmit(saveClick)}>
      {props.additionalInputs}
      <div>
        <TextInput
          label="DSN*"
          placeholder="https://key@host/path/42"
          disabled={props.disableInputs}
          register={register}
          name="dsn"
          error={errors['dsn']?.message}
        />
        <TextInput
          label="Environment"
          placeholder="prod"
          disabled={props.disableInputs}
          register={register}
          name="environment"
          error={errors['environment']?.message}
        />
        {props.submitButton ? props.submitButton : <SaveAndCancelButtons cancelClick={cancelClick} />}
      </div>
    </form>
  )
}
